<template>
	<div id="wrapper" :class="[`flex flex-column`]">
		<TopBar/>
		<Tabs/>
		<Notification/>
		<main id="main" class="flex-grow-2 flex h-100">
			<div class="tabs-content pr flex flex-wrap overflow-hidden w-100">
				<CustomizeTab/>

				<div :class="[`two-cols flex justify-between flex-wrap`, $css(styles.twoCols)]">
					<PreviewTab/>
					<CodeTab/>
				</div>
			</div>
		</main>

		<Footer/>
	</div>
</template>

<script>
	import TopBar from "@/components/TopBar.vue";
	import Footer from "@/components/Footer.vue";
	import Tabs from "@/components/Tabs.vue";
	import CustomizeTab from "@/components/CustomizeTab.vue";
	import PreviewTab from "@/components/PreviewTab.vue";
	import CodeTab from "@/components/CodeTab.vue";
	import {getInMediaQuery as gimq, MQ_SIZES} from "@/utils/cssUtils";
	import Notification from "../components/Notification";

	function styles() {
		return this.$style({
			twoCols: gimq(
				[MQ_SIZES.W, {width: "67.3%"}],
				[MQ_SIZES.D, {width: "100%"}]),
		});
	}

	export default {
		name: "home",
		components: {
			Notification,
			TopBar,
			Tabs,
			Footer,
			CustomizeTab,
			PreviewTab,
			CodeTab,
		},
		computed: {
			styles
		},
	}

</script>

<style lang="scss" scoped>

	.two-cols {
		width: 73.4%;
	}

	@media (min-height: 1300px) and (min-width: 1621px),
		(min-height: 1000px) and (max-width: 1220px) {
		#wrapper {
			height: 100vh;
		}
	}


</style>
